import * as React from "react";
import * as _ from "lodash";
import CarouselSlide from "../share/CarouselSlide";
import Image from "../../components/share/Image"
import EnlargeImage from "../share/EnlargeImage";
import { groupDataForSlide } from "../../util/groupDataForSlide";
import { VideoGallery, HinhAnhGallery } from "../../models/HinhAnhGallery";
import { loadImage } from "../../util/image";
import { GalleryService } from "../../services";
import { DANH_MUC } from "../../const/danh-muc";
import Spinner from '../share/Spinners/Spinners'
import SpinnersImage from "../share/Spinners/SpinnersImage";

export interface Props {
  imageList: HinhAnhGallery[];

}
export interface State {
  isOpenEnlargeImage: boolean;
  enlargeImageSrc: string;
}

let count = 0;
let group = 1;
let arrayNumber = _.range(1, 17);
const slides = _.groupBy(arrayNumber, _ => {
  if (count === 4) {
    count = 0;
    group++;
  }
  count++;
  return group;
});

export default class CoSoVatChat extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      isOpenEnlargeImage: false,
      enlargeImageSrc: null,
      loading: false,
      imageList: []
    };
  }

  componentDidMount() {
    GalleryService.getList(DANH_MUC.GALLERY_HOAT_DONG_SU_KIEN, "h", 1, 20)
      .then(value => {
        if (value.galleries) {
          if (value.galleries.length > 0) {
            const _lala: any = value.galleries
            const _imageList: any = groupDataForSlide<HinhAnhGallery>(JSON.parse(_lala[0].data['files']), 4);
            this.setState({
              loading: true,
              imageList: _imageList
            });
          }

        }
      });
  }
  render() {
    let { isOpenEnlargeImage, enlargeImageSrc, loading, imageList } = this.state;
    return (
      <div className="block cosovatchat">
        <div className="container">
        <div className="col text-center block-title">
          FACILITIES
        </div>
        {
          this.state.loading ? (
            <div>
              <CarouselSlide
                id="cosovatchatCarousel"
                arrowNextClass="carousel-control-next carousel-control-next-cosovatchat"
                arrowPrevClass="carousel-control-prev carousel-control-prev-cosovatchat"
              >
                {Object.keys(imageList).map(key => {
                  return (
                    <div key={key} className="row col nopadding nomargin">
                      {imageList[key].map(number => {
                        return <div key={`${number.file_system_guid_id}`} className="col-md-3" style={{padding: "5px"}}>
                          <a style={{boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px"}}
                            href="#"
                            className="case_studies--item case_studies--item-child case_studies--item-child-nomargin hotspot-wrapper"
                            onClick={event => this.onImageClick(event, loadImage(number.path))}
                          >
                            <Image
                              src={loadImage(number.path)}
                              alt=""
                              className="img-responsive"
                              classPlaceHolder="lazy-image-co-so-vat-cat"
                            />
                          </a>
                        </div>
                      })}
                    </div>
                  );
                })}
              </CarouselSlide>
            </div>
          ) : <SpinnersImage type={'placeholde'} loading={true} />
        }


        {isOpenEnlargeImage && (
          <EnlargeImage
            imageSrc={enlargeImageSrc}
            onCloseRequest={() => this.setState({ isOpenEnlargeImage: false })}
          />
        )}
        </div>
      </div>
    );
  }

  onImageClick = (event, image) => {
    event.preventDefault();
    this.setState({
      isOpenEnlargeImage: true,
      enlargeImageSrc: image
    });
  };
}
